export default __webpack_public_path__ + "static/media/president.c0971ea3.png";